import { AddIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { FaQuoteLeft } from 'react-icons/fa';
import CitationItemRow from './CitationItemRow';
import ResourcesUploadCard from './ResourcesUploadCard';
import { PaperService } from '../../services/paperService';
import { useRecoilState } from 'recoil';
import { paperResources } from '../../atoms/rootAtom';
import { BibContent } from '../../types/Writer/BibContent';
import { cloneDeep } from "lodash";
import { domToContent, handleInlineCursor, pxToRem } from "../../utils/editor.ts";
import useOutlineStore from "../../stores/modules/outline.ts";
import useEditorStore from "../../stores/modules/editor.ts";
import { OutlineNodeType } from "../../types/Writer/OutlineNode.ts";
// import { selectedCrossReferences } from '../../atoms/rootAtom';

const CitationPanel: React.FC<{
  editor,
  paperId: string
}> = ({ editor, paperId }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isResourcesUploading, setIsResourcesUploading] = useState<boolean>(false);
  const inputResourcesRef = useRef<HTMLInputElement | null>(null);
  const [res, setRes] = useRecoilState(paperResources);
  const [selectedResource, setSelectedResource] = useState<BibContent[]>([]);
  const { outline, setOutline, nodeList, setOutlineIsChange } = useOutlineStore()
  const { currentCursor, resources, setResources, setFocusEditor } = useEditorStore()
  const [lastInsert, setLastInsert] = useState<string>('')
  const [doneLoading, setDoneLoading] = useState<boolean>(false)
  const [isEditMode, setIsEditMode] = useState<boolean>(false)
  const [editingResource, setEditingResource] = useState<BibContent | null>(null)
  const [searchQuery, setSearchQuery] = useState<string>('')
  // const [selectedReferences, setSelectedReferences] = useRecoilState(selectedCrossReferences);

  useEffect(() => {
    if (lastInsert) {
      handleInlineCursor(nodeList[currentCursor.nodeIndex], lastInsert)
      setLastInsert('')
    }
  }, [lastInsert]);

  useEffect(() => {
    if (resources?.length) {
      const result = cloneDeep(resources)
      setRes(result);
    }
  }, [resources]);

  const removeResource = async(index: number) => {
    // 清理nodeList中相关的所有cite
    // const removeItem = res[index]
    const newNodeList = cloneDeep(outline.nodes)
    newNodeList.forEach(item => {
    item?.children?.forEach(node => {
      const nodeInfo = domToContent(node)
      if (node.cite && Object.keys(node.cite).length) {
        delete node.cite['1']
        node.content = (nodeInfo.content as any).replaceAll(`($cite{${1}}$)`, '')
      } else if (node.type === OutlineNodeType.Section) {
        if (node.name !== nodeInfo.content) {
          node.name = nodeInfo.content;
        }
      } else if (node.type === OutlineNodeType.Paragraph) {
        node.content = nodeInfo.content;
      }
    })
   })

    outline.nodes = [...newNodeList]
    setOutline(outline)
    setOutlineIsChange(true)
    setRes(prevResources => {
      return prevResources.filter((_, i) => i !== index);
    });

    const newResources =  resources.filter((_, i) => i !== index)
    setResources(newResources);
    await PaperService.deleteCustomBib({
      paperId,
      bibDict: { bibID: resources[index].ID }
    })

  };

  const resourcesOnClick = () => {
    if (inputResourcesRef.current) {
      inputResourcesRef.current.click();
    }
  };

  const handleResourcesUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.name?.indexOf('bib') > -1) {
      setIsResourcesUploading(true);
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const content = e.target?.result;
        if (typeof content === 'string') {
          PaperService.extractBibContent({ paperId, bib_content: content }).then(
            results => {
              setResources([...res, ...results]);
              setIsResourcesUploading(false)
            }
          )
        }
      };
      reader.readAsText(file);
    } else {
      alert('Please upload a valid .bib file');
    }
  };

  const addResources = () => {
    setIsEditMode(false)
    setEditingResource(null)
    setFocusEditor(false)
    onOpen();
  }

  const editResource = (resource: BibContent) => {
    setIsEditMode(true)
    setEditingResource(resource)
    setFocusEditor(false)
    onOpen();
  }

  const resourceOnSelection = (resource: BibContent) => {
    setSelectedResource((prevSelected) => {
      const exists = prevSelected.some((ref) => ref === resource);
      if (exists) {
        return prevSelected.filter((ref) => ref !== resource);
      } else {
        return [...prevSelected, resource];
      }
    });
  }

   /**
   * insert cite
   * @param e
   */
   const insertCite = (e) => {
    e.stopPropagation()
    selectedResource.forEach((cite) => {
      editor?.commands.insertReference({
        type: 'cite',
        content: cite.ID,
        tooltip: cite.title
      })
    })
    setSelectedResource([])
  }

  // const citeResource = () => {
  //   const selection = window.getSelection();
  //   if (!selection || selection.rangeCount === 0) return;
  //   const newNodeList = cloneDeep(nodeList)
  //   const node = newNodeList[currentCursor.nodeIndex]
  //   let slotContent = ''
  //   if (!node.cite) {
  //     node.cite = {}
  //   }
  //   let lastSlot = ''
  //   selectedResource.forEach((ref, index) => {
  //     const id = ref.index
  //     node.cite[id] = {
  //       value: ref.title,
  //       id: ref.ID
  //     }
  //     slotContent += `($cite{${id}}$)`
  //     if (index === selectedResource.length - 1) {
  //       lastSlot = `($cite{${id}}$)`
  //     }
  //     const resItem = findIndex(resources, { index: ref.index })
  //     if (resItem !== -1) {
  //       if (!resources[resItem]?.count) {
  //         resources[resItem].count = 0
  //       }
  //       resources[resItem].count += 1
  //       setResources([...resources])
  //     }
  //   })
  //   const key = node.type === OutlineNodeType.Section ? 'name' : 'content'
  //   node[key] = insertContentToDom(node, currentCursor, slotContent).content
  //   setNodeList([...newNodeList])
  //   setSelectedResource([])
  //   setOutlineIsChange(true)
  //   setLastInsert(lastSlot)
  // }

  /**
   * create custom bib
   */
  const createCustomBib = async (bibList: any) => {
    setDoneLoading(true)
    const res = await PaperService.addCustomBib({
      paperId,
      bibList
    })
    setDoneLoading(false)
    setResources(res)
    closeModal()
  }

  
  /**
   * edit custom bib
   */
  const editCustomBib = async (bibList: any) => {
    setDoneLoading(true)
    const res = await PaperService.editCustomBib({
      paperId,
      bibList
    })
    setDoneLoading(false)
    setResources(res)
    closeModal()
  }

  const closeModal = () => {
    setIsEditMode(false)
    setEditingResource(null)
    onClose()
    setFocusEditor(true)
  }

  // 过滤引用列表
  const filteredRes = res.filter((ref) => {
    if (!searchQuery?.trim()) return true;
    const query = searchQuery?.toLowerCase();
    
    // 获取所有可能的字段值进行搜索
    const searchableFields = [
      'ID', 'title', 'author', 'journal', 'number', 'pages', 'volume', 'year',
      'address', 'publisher', 'editor', 'booktitle', 'series', 'school', 
      'institution', 'howpublished', 'note', 'month', 'organization'
    ];
    
    // 检查是否有任何字段包含查询内容（每个字段单独匹配）
    return searchableFields.some(field => {
      const fieldValue = ref[field];
      return fieldValue && fieldValue?.toString()?.toLowerCase()?.includes(query);
    });
  });

  return (
    <Flex flexDir={'column'} onClick={(e) => e.stopPropagation()} overflow={'hidden'}>
      {/* 搜索输入框 */}
      <Box px={'0.5rem'} pb={'0.5rem'}>
        <InputGroup size="sm">
          <InputLeftElement pointerEvents="none">
            <Box
              as="img"
              src="/static/editor/search-normal.svg"
              alt="Search"
              w={5}
              h={5}
            />
          </InputLeftElement>
          <Input
            placeholder="Search Citation"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            bg="white"
            border="1px solid #E2E8F0"
            borderRadius="10px"
            fontSize="14px"
            w={'60%'}
            _placeholder={{ color: '#A0AEC0' }}
            _focus={{
              border: "1px solid #E2E8F0",
              boxShadow: "none"
            }}
          />
        </InputGroup>
      </Box>
        
      <Flex px={'0.5rem'} flexDir={'column'} overflow={'auto'} h={pxToRem(90)} css={{
        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#9EC3E8",
          borderRadius: "2px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#2b6cb0",
        }
      }}>
        {filteredRes.map((ref, index) => {
          // 找到原始数组中的索引，用于删除操作
          const originalIndex = res.findIndex(r => r.ID === ref.ID);
          return (
            <CitationItemRow
              key={ref.ID + index}
              resource={ref}
              selectedResource={selectedResource}
              resourceOnSelection={resourceOnSelection}
              resourceOnDelete={() => removeResource(originalIndex)}
              resourceOnEdit={() => editResource(ref)} />
          );
        })}
      </Flex>
      <Flex flexDir={'row'} justifyContent={'space-between'} pt={5} pb={2}>
        <Box>
          <Button w={pxToRem(99)} h={pxToRem(33)}
                  size={"xs"}
                  variant={'outline'}
                  fontSize={pxToRem(14)}
                  leftIcon={
                    <FaQuoteLeft />
                  }
                  onClick={insertCite}
          >
            Cite
          </Button>
        </Box>
        <Box>
          <Button w={pxToRem(99)} h={pxToRem(33)}
                  size={"sm"}
                  variant={'solid'}
                  colorScheme='brand'
                  fontSize={pxToRem(14)}
                  leftIcon={
                    <AddIcon />
                  }
                  onClick={() => addResources()}
          >
            Add
          </Button>
        </Box>
      </Flex>

      <Modal isOpen={isOpen} onClose={closeModal} size={'lg'} closeOnOverlayClick={false}>
        <ModalOverlay bg={'whiteAlpha.400'} />
        <ModalContent minW={pxToRem(730)} bg={'#fbfcff'} top={'20%'} borderRadius={pxToRem(24)}>
          <ModalCloseButton
            _focusVisible={{ boxShadow: 'none' }}
            bg={'#D3D7E2'}
            width={pxToRem(24)}
            height={pxToRem(24)}
            color={'#8E9ABC'}
            top={pxToRem(20)}
            right={pxToRem(20)}
            fontSize={'8px'}
            borderRadius={'50%'}/>
          <ModalBody p={8} bg={'#FBFCFF'} border={'1px solid #D3D7E2'} borderRadius={pxToRem(24)}>
            <ResourcesUploadCard
              doneLoading={doneLoading}
              createCustomBib={createCustomBib}
              editCustomBib={editCustomBib}
              handleFileUploadInputElementForResourcesOnClick={resourcesOnClick}
              resources={res}
              isResourcesUploading={isResourcesUploading}
              inputResourcesRef={inputResourcesRef}
              handleResourcesUpload={handleResourcesUpload}
              removeResource={removeResource}
              closeModal={closeModal}
              isEditMode={isEditMode}
              editingResource={editingResource}
            />
            <input
              ref={inputResourcesRef}
              type="file"
              onChange={handleResourcesUpload}
              style={{ display: "none" }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  )
}

export default CitationPanel;


